import axios from 'axios';
import router from '../router';
export class Utils {
  public static toggleBodyClass(addRemoveClass: string, className: string) {
    const el = document.body;

    if (addRemoveClass === 'addClass') {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }

  public static isLoggedIn(): boolean {
    return sessionStorage.getItem('jwt') ? true : false;
  }

  public static ensureAxiosJwtHeaders(): void {
    if (Utils.isLoggedIn()) {
      axios.defaults.headers.common.Authorization = `JWT ${sessionStorage.getItem('jwt')}`;
    }
  }

  public static intercept401(): void {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (401 === error.response.status) {
          router.replace('/login');
        }
      },
    );
  }
}
